import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useMemo } from "react";

const Expense = () => {

  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);

  const credit = useMemo(() => {
    return files
      .filter(f => f.stat == 1)
      .reduce((acc, f) => acc + Number(f.amount || 0), 0);
  }, [files]);

  const debit = useMemo(() => {
    return files
      .filter(f => f.stat == -1)
      .reduce((acc, f) => acc + Number(f.amount || 0), 0);
  }, [files]);

const balance = credit - debit;

  // const BASE_URL = "http://localhost:8080";

  const BASE_URL = "https://dbbackend.hmtbasic2ai.info";

  const fetchFiles = async () => {

    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      const res = await axios.get(
        `${BASE_URL}/api/file/upload/files`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      setFiles(res.data.data);

    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFiles();
  }, []);

  const handleDelete = async (fileId) => {

    try {

      const result = await Swal.fire({
        title: "Are you sure?",
        text: "This file will be moved to trash.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      });

      if (!result.isConfirmed) return;

      const token = localStorage.getItem("token");

      await axios.put(
        `${BASE_URL}/api/file/upload/delete`,
        { file_id: fileId },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: "File moved to trash.",
        timer: 1500,
        showConfirmButton: false
      });

      fetchFiles();

    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Delete Failed",
        text: err.response?.data?.message || "Something went wrong",
      });
    }
  };

  return (
    <div className="container pt-4 bg-white">

      <h3 className="mb-3" style={{fontSize:'30px'}}>Your Files</h3>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
        <table className="table table-striped">
          <thead>
            <th>Total Credit</th>
            <th>Total Debit</th>
            <th>Profit / Loss</th>
          </thead>
          <tbody>
            <tr>
              <td>{credit}</td>
              <td>{debit}</td>
              <td>{balance}</td>
            </tr>
          </tbody>
        </table>
        <div className="table-responsive">
          <table className="table table-bordered table-hover align-middle">

            <thead className="table-dark">
              <tr>
                <th>#</th>
                <th>Proof File</th>
                <th>File Type</th>
                <th>Debit</th>
                <th>Credit</th>
                {/* <th>Remarks</th> */}
                <th>Uploaded Date</th>
                {/* <th>Actions</th> */}
              </tr>
            </thead>

            <tbody>

              {files.length > 0 ? (
                files.map((file, index) => (
                  <tr key={file.file_id}>

                    <td>{index + 1}</td>

                    {/* File Name */}
                    <td>
                      {file.stored_file_name.length > 30
                        ? file.stored_file_name.slice(0, 30) + "..."
                        : file.stored_file_name}
                    </td>

                    {/* Type */}
                    <td>
                      {file.file_type === "application/pdf" ? (
                        <span className="badge bg-danger">PDF</span>
                      ) : (
                        <span className="badge bg-success">IMAGE</span>
                      )}
                    </td>

                    {/* Amount */}
                    <td>
                      {file.stat == -1 ? (
                        <span className="text-black fw-semibold">
                          {/* <i className="bi bi-graph-up-arrow"></i>  */}
                          {file.amount}
                        </span>
                      ):<i className="bi bi-dash"></i>}
                    </td>
                    <td>
                      {file.stat == 1 ? (
                        <span className="text-black fw-semibold">
                          {/* <i className="bi bi-graph-down-arrow"></i>  */}
                          {file.amount}
                        </span>
                      ):<i className="bi bi-dash"></i>}
                    </td>


                    {/* Remarks */}
                    {/* <td style={{ maxWidth: "250px" }}>
                      {file.remarks?.length > 80
                        ? file.remarks.slice(0, 80) + "..."
                        : file.remarks}
                    </td> */}

                    {/* Date */}
                    <td>
                      {new Date(file.creation_date).toLocaleString()}
                    </td>

                    {/* Actions */}
                    {/* <td className="d-flex gap-2">

                      <a
                        href={`${BASE_URL}/files/${file.stored_file_name}`}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-sm btn-primary"
                      >
                        <i className="bi bi-eye"></i>
                      </a>

                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleDelete(file.file_id)}
                      >
                        <i className="bi bi-trash"></i>
                      </button>

                    </td> */}

                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center text-danger">
                    No files uploaded yet
                  </td>
                </tr>
              )}

            </tbody>

          </table>

        </div>
        </>
      )}

    </div>
  );
};

export default Expense;